import Tabby from 'tabbyjs';
import { delay } from '../helpers/utils/delay';

class Tabs {
	constructor(container) {
		this.container = container;
		this.tabs = null;
		this.tabsParent = null;
		this.tabsContent = [];
		this.selector = '[data-tabs]';

		this.getTabElements();

		if (this.elems.length > 0) {
			this.setTabIDs();
			this.initTabs();
			this.initNav();
			this.getTabHeights();
			this.setEvents();
		}
	}

	getTabElements() {
		this.elems = this.container.querySelectorAll(this.selector);
		this.tabsParent = this.container.querySelector('.tabs-main');
		this.tabsContent = this.container.querySelectorAll('.tabs-main__item');
		this.tabNav = this.container.querySelectorAll('.tabs-nav');
	}

	setTabIDs() {
		this.elems.forEach((elem, i) => {
			elem.setAttribute('data-tabs', i);
		});
	}

	initTabs() {
		this.elems.forEach((elem, i) => {
			this.tabs = new Tabby(`[data-tabs="${i}"]`);
			elem.tabs = this.tabs; // eslint-disable-line no-param-reassign
			this.constructor.handleInitalTab(elem);
		});
	}

	initNav() {
		if (this.tabNav.length > 0 && this.tabs !== null) {
			this.tabNav.forEach((elem) => {
				elem.addEventListener('click', () => {
					this.tabs.toggle(elem.dataset.target);
				});
			});
		}
	}

	getTabHeights() {
		this.containerHeight = 0;
		this.tabsContent.forEach((elem) => {
			const wasHidden = elem.hidden;
			elem.style.display = 'block'; // eslint-disable-line no-param-reassign
			if (wasHidden) {
				elem.hidden = false; // eslint-disable-line no-param-reassign
			}
			const height = elem.clientHeight;
			elem.removeAttribute('style');
			if (wasHidden) {
				elem.hidden = true; // eslint-disable-line no-param-reassign
			}
			elem.style.setProperty('--tab-height', `${height}px`);

			if (height > this.containerHeight) {
				this.containerHeight = height;
			}
		});

		this.tabsParent.style.setProperty('--tabs-max-height', `${this.containerHeight}px`);
	}

	setEvents() {
		document.addEventListener(
			'tabby',
			(e) => {
				const { previousContent, content } = e.detail;
				this.constructor.tabTransition(previousContent, content);
				this.constructor.tabBackground(previousContent, content);
				this.constructor.tabIcons(previousContent, content);
			},
			false
		);
	}

	static tabTransition(previousTab, nextTab) {
		const transitionSpeed = 200;
		previousTab.classList.add('is-invisible');

		delay(transitionSpeed).then(() => {
			previousTab.classList.remove('is-active');
			nextTab.classList.add('is-active', 'is-invisible');
		});

		delay(transitionSpeed + 10).then(() => {
			nextTab.classList.remove('is-invisible');
		});
	}

	static handleInitalTab(elem) {
		const currentTab = elem.querySelector('[aria-selected=true]');

		if (currentTab.hash !== null) {
			const currentContent = document.querySelector(currentTab.hash);
			currentContent.classList.add('is-active');
		}
	}

	static tabBackground(previousTab, nextTab) {
		const background = document.querySelector('.page-background');
		if (background != null) {
			if (nextTab.id === 'tab-a-z') {
				background.classList.add('active');
			} else if (previousTab.id === 'tab-a-z') {
				background.classList.remove('active');
			}
		}
	}

	static tabIcons(previousTab, tab) {
		const icons = document.querySelector("#icons");
		if(icons){
			icons.classList.remove(previousTab.id)
			icons.classList.add(tab.id);
		}
	}
}

new Tabs(document); // eslint-disable-line no-new
